import React, { useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowUpRight, FiX } from 'react-icons/fi';
import { useBot } from '../../context/BotContext';
import BotMascot from './BotMascot';
import BotChat from './BotChat';

export function BotFooterInvite() {
  const { page } = useBot();
  return <div className="container txbot-invite-wrap"><Link className="txbot-invite" to="/ai">
    <BotMascot className="txbot-invite-mascot" />
    <div><span className="txbot-eyebrow">YOUR LEARNING SIDEKICK</span><h2>{page.headline}</h2><p>Meet ThiranX Bot. Find a path, make a plan, or practise something new.</p></div>
    <span className="txbot-invite-cta">Meet your bot<FiArrowUpRight aria-hidden="true" /></span>
  </Link></div>;
}

export default function BotCompanion() {
  const { open, setOpen } = useBot();
  const { pathname } = useLocation();
  const panel = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!open) return;
    const previousFocus = document.activeElement;
    const launcher = trigger.current;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.current?.querySelector('textarea')?.focus();
    const onKey = event => {
      if (event.key === 'Escape') { event.preventDefault(); setOpen(false); }
      if (event.key === 'Tab') {
        const nodes = panel.current?.querySelectorAll('a[href], button:not(:disabled), textarea, [tabindex="0"]');
        if (!nodes?.length) return;
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', onKey);
    return () => { document.body.style.overflow = previousOverflow; document.removeEventListener('keydown', onKey); if (previousFocus !== document.body && previousFocus?.isConnected) previousFocus.focus(); else if (launcher?.isConnected) launcher.focus(); };
  }, [open, setOpen]);
  const launch = () => {
    if (pathname === '/ai') {
      document.getElementById('txbot-tab-chat')?.click();
      window.requestAnimationFrame(() => {
        document.getElementById('txbot-workspace')?.scrollIntoView({ behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        document.getElementById('bot-studio-message')?.focus({ preventScroll: true });
      });
    }
    else setOpen(true);
  };
  return <>
    <button ref={trigger} className="txbot-launcher" style={open ? { visibility: 'hidden' } : undefined} tabIndex={open ? -1 : 0} aria-hidden={open || undefined} type="button" onClick={launch} aria-label="Open ThiranX AI assistant" aria-haspopup={pathname === '/ai' ? undefined : 'dialog'} aria-expanded={open}>
      <span className="txbot-launcher-picture"><BotMascot avatar eager /><span className="txbot-launcher-dot" /></span>
      <span className="txbot-launcher-label">Ask ThiranX<span>YOUR LEARNING SIDEKICK</span></span>
      <FiArrowUpRight className="txbot-launcher-arrow" aria-hidden="true" />
    </button>
    {open && <>
      <div className="txbot-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />
      <section ref={panel} className="txbot-panel" role="dialog" aria-modal="true" aria-labelledby="txbot-panel-title">
        <header className="txbot-panel-header"><BotMascot avatar /><div><h2 id="txbot-panel-title">ThiranX Bot</h2><Link to="/ai">Open the full studio <FiArrowUpRight aria-hidden="true" /></Link></div><button type="button" className="txbot-icon-button" aria-label="Close assistant" onClick={() => setOpen(false)}><FiX size={20} /></button></header>
        <BotChat compact />
      </section>
    </>}
  </>;
}
